<template>
  <div class="iam-wrapper">
    <!-- page-wrapper Start-->
    <div class="page-wrapper" id="canvas-bookmark">
      <!-- Page Header Start-->
      <div class="page-main-header">
        <div class="main-header-right row">
          <div class="main-header-left">
            <div class="logo-wrapper">
              <router-link :to="{ name: 'admin-dashboard' }" v-if="isAdmin">
                <img src="../assets/infrabau_logo_positiv_quer.png" alt />
              </router-link>
              <router-link :to="{ name: 'kunde-dashboard' }" v-if="!isAdmin">
                <img src="../assets/infrabau_logo_positiv_quer.png" alt />
              </router-link>
            </div>
          </div>
          <div class="nav-right col">
            <ul class="nav-menus" :class="{ open: mobile_toggle }">
              <li>
                <a href="#"><connection /></a>
              </li>
              <li>
                <a href="#"><feather type="maximize" class="infra-blue" @click="toggle_fullscreen"></feather></a>
              </li>
              <li v-if="isAdmin">
                <a href="#">
                  <sendBoardMessage mode="icon" />
                </a>
              </li>
              <li v-if="!isAdmin" class="onhover-dropdown">
                <a href="#">
                  <KundeBoardMessageIcon />
                </a>
              </li>
              <li>
                <router-link :to="{ name: setLink('nachrichten') }">
                  <a href="#">
                    <feather type="inbox" class="infra-blue"></feather>
                  </a>
                </router-link>
              </li>
              <createItems v-if="isAdmin" />
              <li class="onhover-dropdown">
                <div class="media align-items-center">
                  <img class="align-self-center pull-right img-50 rounded-circle" v-bind:src="this.userImg.url" alt="header-user" />
                </div>
                <ul class="profile-dropdown onhover-show-div p-20">
                  <li v-if="isAdmin">
                    <router-link :to="{ name: 'admin-edit-profile' }"> <feather type="user"></feather>Benutzerprofil </router-link>
                  </li>
                  <li v-if="!isAdmin">
                    <router-link :to="{ name: 'kunde-edit-profile' }"> <feather type="user"></feather>Benutzerprofil </router-link>
                  </li>
                  <li>
                    <a href="#" @click.prevent="logout"> <feather type="log-out"></feather>Logout </a>
                  </li>
                </ul>
              </li>
            </ul>
            <div class="d-lg-none mobile-toggle pull-right" v-on:click="mobile_toggle = !mobile_toggle">
              <feather type="more-horizontal"></feather>
            </div>
          </div>
        </div>
      </div>
      <!-- Page Header Ends -->
    </div>
  </div>
</template>
<script>
var body = document.getElementsByTagName("body")[0];
import { mapState, mapGetters } from "vuex";
import sendBoardMessage from "@/widget/admin/sendBoardMessage.vue";
import createItems from "@/widget/createItems.vue";
import KundeBoardMessageIcon from "@/widget/kunde/KundeBoardMessageIcon.vue";
import connection from "@/components/connection.vue";

export default {
  name: "Search",
  data() {
    return {
      terms: "",
      searchResult: false,
      searchResultEmpty: false,
      toggle_sidebar_var: false,
      clicked: false,
      mobile_toggle: false,
      mobile_search: false,
    };
  },
  components: {
    sendBoardMessage,
    createItems,
    KundeBoardMessageIcon,
    connection,
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.searchData,
    }),
    ...mapGetters({
      apiSettings: "auth/apiSettings",
      apiToken: "auth/apiToken",
      user: "auth/user",
      userImgFormats: "auth/userImgFormats",
      userImg: "auth/userImg",
      msgBoards: "msg/statusBoards",
      isAdmin: "auth/isAdmin",
      unseenMessages: "chat/unseenMessages",
    }),
  },
  async created() {
    await this.$store.dispatch("msg/initBoards");
    await this.$store.dispatch("chat/initChat");
  },
  methods: {
    setLink(target) {
      if (this.isAdmin && target == "nachrichten") return "admin-nachrichten";
      if (!this.isAdmin && target == "nachrichten") return "kunde-nachrichten";
    },
    debug() {
      this.$store.dispatch("auth/debug");
    },
    logout() {
      this.$store.dispatch("auth/logout");
      this.$store.dispatch("msg/shutdown");
      this.$store.dispatch("chat/shutdownChat");
      this.$router.push("/").catch((error) => {
        console.log("logging out");
        console.log(error);
      });
    },
    searchTerm: function() {
      this.$store.dispatch("menu/searchTerm", this.terms);
    },
    addFix() {
      body.classList.add("offcanvas");
      this.searchResult = true;
    },
    removeFix() {
      body.classList.remove("offcanvas");
      this.searchResult = false;
      this.terms = "";
    },
    toggle_sidebar() {
      (this.toggle_sidebar_var = !this.toggle_sidebar_var), (this.clicked = !this.toggle_sidebar_var), this.$emit("clicked", this.clicked);
    },
    toggle_fullscreen() {
      if ((document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
  },
  watch: {
    menuItems: function() {
      this.terms ? this.addFix() : this.removeFix();
      if (!this.menuItems.length) this.searchResultEmpty = true;
      else this.searchResultEmpty = false;
    },
  },
};
</script>

<style>
/* raleway-regular - latin */
@font-face {
  font-family: "Raleway";
  font-style: normal;
  font-weight: 400;
  src: url("../assets/fonts/raleway-v18-latin-regular.eot"); /* IE9 Compat Modes */
  src: local(""), url("../assets/fonts/raleway-v18-latin-regular.eot?#iefix") format("embedded-opentype"),
    /* IE6-IE8 */ url("../assets/fonts/raleway-v18-latin-regular.woff2") format("woff2"),
    /* Super Modern Browsers */ url("../assets/fonts/raleway-v18-latin-regular.woff") format("woff"),
    /* Modern Browsers */ url("../assets/fonts/raleway-v18-latin-regular.ttf") format("truetype"),
    /* Safari, Android, iOS */ url("../assets/fonts/raleway-v18-latin-regular.svg#Raleway") format("svg"); /* Legacy iOS */
}
/* raleway-500 - latin */
@font-face {
  font-family: "Raleway";
  font-style: normal;
  font-weight: 500;
  src: url("../assets/fonts/raleway-v18-latin-500.eot"); /* IE9 Compat Modes */
  src: local(""), url("../assets/fonts/raleway-v18-latin-500.eot?#iefix") format("embedded-opentype"),
    /* IE6-IE8 */ url("../assets/fonts/raleway-v18-latin-500.woff2") format("woff2"),
    /* Super Modern Browsers */ url("../assets/fonts/raleway-v18-latin-500.woff") format("woff"),
    /* Modern Browsers */ url("../assets/fonts/raleway-v18-latin-500.ttf") format("truetype"),
    /* Safari, Android, iOS */ url("../assets/fonts/raleway-v18-latin-500.svg#Raleway") format("svg"); /* Legacy iOS */
}
/* raleway-700 - latin */
@font-face {
  font-family: "Raleway";
  font-style: normal;
  font-weight: 700;
  src: url("../assets/fonts/raleway-v18-latin-700.eot"); /* IE9 Compat Modes */
  src: local(""), url("../assets/fonts/raleway-v18-latin-700.eot?#iefix") format("embedded-opentype"),
    /* IE6-IE8 */ url("../assets/fonts/raleway-v18-latin-700.woff2") format("woff2"),
    /* Super Modern Browsers */ url("../assets/fonts/raleway-v18-latin-700.woff") format("woff"),
    /* Modern Browsers */ url("../assets/fonts/raleway-v18-latin-700.ttf") format("truetype"),
    /* Safari, Android, iOS */ url("../assets/fonts/raleway-v18-latin-700.svg#Raleway") format("svg"); /* Legacy iOS */
}
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-weight: 700 !important;
}

.icon-button {
  background: #004f7d;
  color: white;
  margin-left: 5px;
}

.icon-button:hover {
  background: white;
  color: #004f7d;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}

.pointer {
  cursor: pointer;
}
.page-wrapper .page-main-header {
  width: 100% !important;
  margin-left: 0px !important;
}

.logo-wrapper img {
  width: auto !important;
  height: auto !important;
}

.loader_text {
  font-size: 0.8em;
}

.logo-wrapper {
  margin-right: 50px;
}
.page-wrapper .page-body-wrapper footer {
  margin-left: 0px !important;
}

.no-link-decoration,
.no-link-decoration:hover {
  color: inherit;
  background-color: inherit;
  text-decoration: none;
}

.scaleUpHover:hover {
  transform: scale(1.02);
  -moz-transform: scale(1.02);
  -webkit-transform: scale(1.02);
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}

.scaleUpHoverBig:hover {
  transform: scale(1.1);
  -moz-transform: scale(1.1);
  -webkit-transform: scale(1.1);
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}

.display-block {
  display: block;
}

.page-main-header .main-header-right .nav-right > ul {
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}

.page-main-header .main-header-right .nav-right > ul > li {
  height: 50px !important;
  align-items: center;
  display: flex;
}
.page-main-header .main-header-right .nav-right > ul > li:first-child {
  width: auto !important;
  margin-left: auto !important;
  margin-right: 0 !important;
}
.page-main-header .main-header-right .nav-right > ul > li:last-child {
  border-right: 0 solid transparent !important;
}
.page-main-header .main-header-right .nav-right ul li svg {
  margin-top: 0 !important;
}
.page-main-header .main-header-right .nav-right .profile-dropdown {
  top: 50px !important;
}

.page-main-header .main-header-right .nav-right .profile-dropdown:before,
.page-main-header .main-header-right .nav-right .profile-dropdown:after {
  right: 28px !important;
}

.infra-icon-desc {
  vertical-align: super;
  font-family: inherit;
}

.disabled {
  pointer-events: none !important;
}

.default-table {
  display: table;
  width: 100%;
  margin-bottom: 25px;
}

.default-table-legend > div {
  font-weight: 700;
}
.default-table-row,
.default-table-legend {
  width: 100%;
  display: table-row;
  text-decoration: none;
}

.default-table-row > div,
.default-table-legend > div {
  display: table-cell;
  padding: 12px 16px;
  border-bottom: 2px solid lightgrey;
}

.default-table-row:hover {
  background: lightgrey;
}

.default-table-row:nth-child(even) {
  background: rgb(245, 245, 245);
}

.default-table-head,
.headline_under {
  position: relative;
  color: #004f7d;
  font-size: 20px;
  border-bottom: 2px solid #004f7d;
  width: 100%;
  margin-bottom: 10px;
}

.maxwidth {
  width: 100% !important;
}

.small-icon {
  height: 20px;
  width: 20px;
}
body .page-header-right {
  display: none !important;
}
.tiny-icon {
  height: 15px;
  width: 15px;
}

.tight-icon {
  margin-left: 5px;
}

.v-super {
  display: inline-block;
  margin-left: 0px;
  vertical-align: "middle";
}

.red {
  color: red !important;
}

.green {
  color: green !important;
}

.flex-between {
  justify-content: space-between;
}

.flex-inline {
  display: inline-flex;
}

.width-100 {
  width: 100%;
}

.vue-dropzone.dropzone {
  position: relative !important;
  border: 0px dashed #003e76 !important;
  background: rgba(0, 62, 118, 0.2) !important;
  border-radius: 8px !important;
  padding: 0 !important;
}

.vue-dropzone.dropzone .dz-preview {
  background-color: transparent !important;
  margin: 0 !important;
  vertical-align: top;
  border: 0px solid #acacac !important;
  padding: 0 !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  font-size: 14px;
}
.dropzone .dz-preview .dz-progress,
.dropzone .dz-preview .dz-success-mark,
.dropzone .dz-preview .dz-error-mark {
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin-left: 0px !important;
}

.dropzone .dz-preview .dz-details {
  display: none;
}

.icon-clickable-right {
  position: absolute;
  display: inline;
  right: 0px;
  cursor: pointer;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.infra-blue {
  color: #004f7d;
}

.infra-grey {
  color: rgb(201, 201, 201);
}

.inactive {
  pointer-events: none;
}

.z-bottom {
  z-index: 1;
}

.z- {
  z-index: 999;
}

.progress-in-table {
  width: 80% !important;
  margin-top: 0px !important;
}

#infra-clock {
  background-color: rgb(14, 80, 139);
  background: -moz-linear-gradient(-45deg, rgba(14, 80, 139, 1) 0%, rgba(0, 62, 118, 1) 100%);
  background: -webkit-linear-gradient(-45deg, rgba(14, 80, 139, 1) 0%, rgba(0, 62, 118, 1) 100%);
  background: linear-gradient(-45deg, rgba(14, 80, 139, 1) 0%, rgba(0, 62, 118, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#0e508b",endColorstr="#003e76",GradientType=1);
}

.card,
.vdp-datepicker .vdp-datepicker__calendar {
  box-shadow: 0px 8px 8px rgba(60, 60, 60, 0.1) !important;
  -webkit-box-shadow: 0px 8px 8px rgba(60, 60, 60, 0.1) !important;
  overflow: hidden;
}

.icon-margin-right {
  margin-right: 10px;
}

.multi-input-row {
  width: auto !important;
  align-items: flex-start;
}

.form-container {
  position: relative;
}

.form-container .editor-checkmark {
  position: absolute;
  right: 10px;
  bottom: 10px;
}

.v-tt {
  vertical-align: text-top;
}
.loader_fs {
  top: 0;
  left: 0;
  justify-content: center;
}

.loader_fs .loader {
  position: absolute;
  top: auto !important;
  bottom: auto !important;
  right: auto !important;
  left: auto !important;
  display: block;
  width: 100% !important;
  height: 100% !important;
  display: flex !important;
  z-index: 999 !important;
}

.loader-text {
  font-size: 0.8em;
  margin: auto;
}

.error {
  color: red;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
}

.flex-row-sb {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.flex-row-end {
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
}

.nav-tabs .nav-link {
  font-weight: 700;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border: 0 solid transparent !important;
}
.nav-tabs .nav-item a {
  display: flex;
}
.nav-tabs .nav-item svg {
  width: 18px;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #0e508b !important;
  background-color: #fff !important;
  border-color: #fff !important;
  border-bottom: 2px solid #0e508b !important;
}
.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  background-color: #fff;
}
.vdp-datepicker__calendar {
  width: 100% !important;
  height: 350px !important;
}
.authentication-box .theme-form,
.authentication-box .theme-form * {
  text-align: center;
}
.onhover-show-div {
  box-shadow: 0px 8px 8px rgba(60, 60, 60, 0.1) !important;
  -webkit-box-shadow: 0px 8px 8px rgba(60, 60, 60, 0.1) !important;
  border-color: transparent !important;
  padding: 0 !important;
  padding-top: 20px;
}
.onhover-show-div li {
  padding: 15px 20px 0 20px !important;
  background-color: #fff;
}
.onhover-show-div li:last-child {
  padding-bottom: 15px !important;
}
.onhover-dropdown:hover .onhover-show-div:after {
  display: none !important;
}
.datatable-vue table tbody tr td svg,
.small-dropzone-buttons svg {
  max-width: 15px;
  height: auto;
  line-height: 20px;
}
.table thead th:last-child,
.table tbody td:last-child {
  text-align: right;
}
table tbody td:first-child {
  text-align: left !important;
}
.input-group {
  justify-content: flex-end !important;
}
.default-table-legend > div:last-child,
.default-table-row > div:last-child {
  text-align: right;
}

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  position: relative;
}

.loader-relative {
  background: none;
  backdrop-filter: none;
}

.loader-container {
  position: relative;
  display: flex;
  flex-flow: column;
  justify-content: center;
  margin-top: 25px;
  margin-bottom: 25px;
}

.loader-message {
  margin: auto;
  font-size: 0.8em;
}

#iam-pagination {
  margin-top: 50px;
}

.dropzone .dz-preview .dz-image img {
  max-width: 100%;
}

.clickable-rows tr td:hover {
  cursor: pointer;
}

.dropzone.dropzone-with-info.vue-dropzone .dz-preview .dz-details {
  display: inline-block;
  position: relative;
  width: 100%;
  bottom: 0 !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%);
  height: 100% !important;
}

.dropzone.dropzone-with-info.vue-dropzone .dz-preview {
  position: relative;
  pointer-events: none !important;
}

.dropzone.dropzone-with-info .dz-preview .dz-details .dz-filename {
  height: auto;
}

.dropzone.dropzone.dropzone-with-info.dz-max-files-reached .dz-message {
  display: none;
}

.page-main-header .main-header-right .nav-right > ul > li:nth-child(5) {
  border-left: 1px solid #eff0f1 !important;
  padding-left: 20px !important;
}

.people-list .user-image,
.chat-header img {
  object-fit: cover;
}
</style>
